import { css } from 'emotion'

export const container = css`
  position: relative;
  background-color: #FFF;
  box-shadow: 0px 0px 20px 35px rgba(0,0,0,0.05);
  box-sizing: border-box;
  padding: 1.5em 2em;
  margin: 1em 0;
`
